/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_LoadingInputs */

const en_pc_online_loading = /** @type {(inputs: Pc_Online_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first visit downloads about 13 MB (the compressed app). After that it loads from your browser cache.`)
};

const zh_pc_online_loading = /** @type {(inputs: Pc_Online_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首次访问约下载 13 MB（压缩后的应用），之后从浏览器缓存加载。`)
};

/**
* | output |
* | --- |
* | "The first visit downloads about 13 MB (the compressed app). After that it loads from your browser cache." |
*
* @param {Pc_Online_LoadingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_loading = /** @type {((inputs?: Pc_Online_LoadingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_LoadingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_loading(inputs)
	return zh_pc_online_loading(inputs)
});
export { pc_online_loading as "pc.online.loading" }